
import { computed, defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { TerminalAuthStatus } from '@/views/dashboard/_enum/terminal-auth-status'
import {
  PermissionDetail,
  PermissionFeMap,
  ServicePermissionService, toSubscribeByPriceId,
  BASIC_SERVICE_PERMISSION_NAMES
} from '@/services/service-permission.service'
import { ElMessage } from 'element-plus'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import { AreaType, AreaTypeLabel } from '@/views/dashboard/service/_enum/area-type'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

export default defineComponent({
  props: {
    authStatus: {
      type: Number,
      default: 0
    },
    deviceId: {
      type: String,
      default: ''
    },
    permissionKey: {
      type: String,
      default: ''
    },
    areaType: {
      type: Number,
      default: AreaType.normal
    }
  },

  emits: ['authSuccess'],

  setup (props, context) {
    const { t } = useI18n()
    const injector = useReflectiveInjector()
    const servicePermissionService = injector.get(ServicePermissionService)

    const allPermissionInfo = ref({} as PermissionDetail)

    const isBasicServiceInJP = computed(() => {
      return IS_JP_ONLY_BUILD && BASIC_SERVICE_PERMISSION_NAMES.has(props.permissionKey)
    })

    servicePermissionService.allRightsMap.subscribe(() => {
      allPermissionInfo.value = servicePermissionService.getAllPermissionInfo(props.permissionKey)
    })

    function handleAuth () {
      servicePermissionService.authTerminal({
        permission_names: [props.permissionKey],
        device_ids: [props.deviceId],
        is_auth: true,
      }).then(() => {
        ElMessage.success(t('serviceSubscribe.detailsBarAuthSuccess'))
        context.emit('authSuccess')
      })
    }

    function toSubscribe () {
      if (props.areaType === AreaType.normal) {
        toSubscribeByPriceId({ normal_price_id: allPermissionInfo.value.price_id })
      } else {
        toSubscribeByPriceId({ linux_price_id: allPermissionInfo.value.price_id })
      }
    }

    return {
      TerminalType,
      AreaTypeLabel,
      PermissionFeMap,
      TerminalAuthStatus,
      allPermissionInfo,
      isBasicServiceInJP,
      toSubscribe,
      handleAuth,
    }
  }
})
